import BPButton from 'components/BionicUI/button/BPButton';
import BPContainer from 'components/BionicUI/container/BPContainer';
import BPLinkButton from 'components/BionicUI/linkButton/BPLinkButton';
import BPPopup from 'components/BionicUI/popup/BPPopup';
import { useState } from 'react';
import { OnboardingEye } from '../Eye';
import ProjectApplicationData from './ProjectApplicationData';
import InputBar from '../InputBar';
import BPInstruction from '../../BionicUI/instruction/BPInstruction';
import { SequenceItem } from './OnboardingProjectSequence';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes';
import useOnboardingProjectStore from 'stores/onboardingProjectStore';
import { ProjectV1BaseServerRepo } from 'core/repository/base-server/v1/project.repo';
import BPToast from 'components/BionicUI/toast/BPToast';
import useNotifyStore from 'stores/notifyStore';

const SubmitYourApplication = () => {
  const [showInputBar, setShowInputBar] = useState<boolean>(false);
  const [showReviewPopup, setShowReviewPopup] = useState<boolean>(false);
  const navigate = useNavigate();
  const { setProgressStep, projectInfo, userProject } =
    useOnboardingProjectStore();
  const { setCurrentToast } = useNotifyStore();
  async function handleSubmit(): Promise<void> {
    // setShowReviewPopup(false);
    try {
      const formData = new FormData();
      formData.append('name', projectInfo.name);
      if (projectInfo?.website) formData.append('website', projectInfo.website);
      if (projectInfo?.whitePaper)
        formData.append('whitePaper', projectInfo.whitePaper);
      formData.append('description', projectInfo.description);
      if (projectInfo?.projectVideoUrl)
        formData.append('projectVideoUrl', projectInfo.projectVideoUrl);
      formData.append('xUsername', projectInfo.xUsername);
      // if (projectInfo?.discordGuildId)
      //   formData.append('discordGuildId', projectInfo.discordGuildId);
      if (projectInfo?.telegramUsername)
        formData.append('telegramUsername', projectInfo.telegramUsername);
      formData.forEach((value, key) => {
        console.log(`formData----${key}:`, value);
      });
      let projectRes;

      if (userProject) {
        projectRes = await new ProjectV1BaseServerRepo().reSubmitProject(
          userProject.id,
          formData
        );
      } else {
        projectRes = await new ProjectV1BaseServerRepo().createProject(
          formData
        );
      }
      if (projectRes) {
        await new ProjectV1BaseServerRepo().submitProject(projectRes.id);
        setProgressStep(0);
        navigate(ROUTES.APPLICATION_IN_REVIEW);
      }
    } catch (err: any) {
      console.log('Error:--', err);
      const errMsg = err.response?.data?.message || 'Try again later.';
      setCurrentToast(
        <BPToast message="Failed" description={errMsg} variant="error" />
      );
    }
  }

  return (
    <SequenceItem>
      <div className="flex justify-center w-full max-w-[800px] px-6 gap-[20px] mx-auto items-start">
        <OnboardingEye />
        <BPInstruction
          line1={{
            text: "Congratulations! You've reached the final step.",
            sound: 'projectStep/congratulations-reached-final-step.mp3',
          }}
          line2={{
            text: "By submitting this application you're one step closer to starting the fundraising process on Ground Zero.",
            sound: 'projectStep/by-submitting-this-application.mp3',
          }}
          onAnimComplete={() => setShowInputBar(true)}
        />
      </div>
      {showInputBar && (
        <InputBar onClickBackButton={() => setProgressStep(6)}>
          <BPContainer twWidth="w-auto md:w-[644px] justify-normal">
            <BPButton state="primary" onClick={handleSubmit}>
              Submit
            </BPButton>
          </BPContainer>
          <BPLinkButton
            className="text-[12px]"
            onClick={() => setShowReviewPopup(true)}
          >
            Review your application
          </BPLinkButton>
        </InputBar>
      )}
      {showReviewPopup && (
        <BPPopup widthLimit={800} handleClose={() => setShowReviewPopup(false)}>
          <ProjectApplicationData handleSubmit={handleSubmit} />
        </BPPopup>
      )}
    </SequenceItem>
  );
};

export default SubmitYourApplication;
